<template>
    <div class="book-location">
        <div class="book-location__inner">
            <div class="book-location__content">
                <span class="book-location__decoration" :style="{color: color}"/>

                <div class="book-location__entry">
                    <h3>{{ name }}</h3>

                    <p v-if="text">{{ text }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BookLocation',

    props: {
         name: {
            type: String,
            default: ''
        },

        text: {
            type: String,
            default: ''
        },

        color: {
            type: String,
            default: 'currentColor'
        }
    }
}
</script>
